import aaveGoerliErc20 from '../../Fct/tokens/aaveV2GoerliErc20.json';
import aaveMainnetErc20 from '../../Fct/tokens/aaveV2MainnetErc20.json';
import uniswapDefaultErc20 from '../../Fct/tokens/uniswapDefault.json';
var Tokens = /** @class */ (function () {
    function Tokens() {
    }
    Tokens.aaveGoerliErc20 = aaveGoerliErc20;
    Tokens.aaveMainnetErc20 = aaveMainnetErc20;
    Tokens.uniswapDefaultErc20 = uniswapDefaultErc20;
    return Tokens;
}());
export { Tokens };
